import { IConsoleUser, IExternalID, IUser } from 'types/users';

export const getUserDisplayName = (user: IConsoleUser) =>
	user?.displayName || user?.externalIDs?.[0].id || '';

export const getIUserDisplayName = (user: IUser) =>
	user?.displayName || user?.externalIDs?.[0].id || '';

export const getExternalIdsString = (externalIDs: any) => {
	const externalIds = (externalIDs as IExternalID[]) || [];
	return externalIds?.map(({ id }) => id).join(', ');
};

export const extractTenantsRolesFromUser = (user: IUser) => {
	const res: {
		[index: string]: {
			tenant?: string;
			role?: string;
		};
	} = {};
	user.mappings?.forEach(({ roles, tenants }) => {
		tenants?.forEach(({ name }) => {
			if (!roles?.length) {
				res[name] = {};
			} else {
				roles.forEach(({ name: roleName }) => {
					const uniqueName = `${name || ''}-${roleName || ''}`;
					res[uniqueName] = {
						tenant: name,
						role: roleName
					};
				});
			}
		});
	});

	return res;
};
